import { useEventCallback } from '@cian/react-utils';
import { FC } from 'react';
import { OffersLoadError } from 'shared/components/OffersLoadError';
import { useAppDispatch } from 'shared/hooks';
import { getOffers } from 'shared/thunks/offers';
import { useDeviceType } from '../../context';

export const OffersLoadErrorContainer: FC = () => {
  const dispatch = useAppDispatch();
  const deviceType = useDeviceType();

  const handleRetry = useEventCallback(() => {
    dispatch(getOffers(deviceType));
  });

  return <OffersLoadError onRetry={handleRetry} />;
};
